import React, {useEffect, useState} from 'react';

// @ts-ignore
const SuccessPopUp = ({message, setSuccessPopUp}) => {
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsOpen(false);
            setSuccessPopUp(false)
        }, 3000);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div
            className={`${
                isOpen ? 'translate-x-0' : 'translate-x-[120%]'
            } fixed bottom-5 right-5 transition-transform duration-500 ease-in-out bg-white rounded-2xl z-50`}
        >
            <div className="bg-white p-4 border border-gray-200 rounded-2xl flex space-x-1 items-center border-b-4 border-b-green-600">
                <div className=" mr-2"/>
                    <h1 className="text-gray-800">Success!</h1>
                    <p className="text-gray-800 text-md">{message}</p>
                </div>
            </div>
    );
};

export default SuccessPopUp;